import { render, staticRenderFns } from "./TitleA.vue?vue&type=template&id=4fc1027b&scoped=true"
import script from "./TitleA.vue?vue&type=script&lang=js"
export * from "./TitleA.vue?vue&type=script&lang=js"
import style0 from "./TitleA.vue?vue&type=style&index=0&id=4fc1027b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc1027b",
  null
  
)

export default component.exports